/* eslint-disable no-use-before-define */
import React from 'react'
import { useCalculator,  } from '../use-calculator'
import { hideModal, showBondOrder, cleanObject } from '../../twd'

export const ActionCard = () => {

    const { calcInput, bondInfo, from_} = useCalculator()
    const ci = calcInput
    const bi = bondInfo
    if (!ci || !bi) return null

    const isBuy = ci.action==='B'
    const isSell = ci.action==='S'

    let action = isBuy && (bi.isRestricted || !bi.canTrade) ? BUY_BOND_RESTRICTED
        : isSell && !bi.isHeld ? SELL_BOND_NOT_OWN
        : isBuy && bi.hasAsk ? BUY_BOND_LIVE
        : isBuy && !bi.hasAsk ? BUY_BOND_NO_LIVE
        : isSell && bi.hasBid ? SELL_BOND_LIVE
        : isSell && !bi.hasBid ? SELL_BOND_NO_LIVE
        : null
    if (!action) return null

    return <React.Fragment>
        <div
            className='card card-primary'
            style={{cursor:'pointer'}}
            onClick={() => {
                if (!action.action) return

                hideModal()
                showBondOrder(cleanObject({
                    action: action.action,
                    cusip: bondInfo.cusip,
                    // price: calcOutput.price,
                    // qty: calcOutput.qty,
                    from: from_,
                    ts: Date.now(),

                }))
            }}
        >
        <div className='card-body'>
            <h3 className='card-title text-center'>
                {action.title}
            </h3>
            <div className='vertical-offset-base'>
                {action.text}
            </div>

            {action.button && <div className='text-center'>
            <button className='btn btn-primary' style={{width:'50%'}}>
                {action.button}
            </button>
            </div>}
        </div>
        </div>
    </React.Fragment>
}


const BUY_BOND_LIVE = {
    title: 'This security is available',
    text: 'You can trade this security at the best available price. Keep in mind, current pricing listed in bond details may not align with custom calculations.',
    button: 'Buy',
    action: 'B'
}

const BUY_BOND_NO_LIVE = {
    title: 'This security is not available',
    text: 'There is no live market active for this security. However, you can request a price quote from dealers if you wish to place a trade.',
    button: 'Offer wanted',
    action: 'F'
}

const BUY_BOND_RESTRICTED = {
    title: 'This security is not available',
    text: 'Buy orders for this asset class are not available for online trading. Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders.',
}


const SELL_BOND_LIVE = {
    title: 'This security is available',
    text: 'You can trade this security at the best available price. Keep in mind, current pricing listed in bond details may not align with custom calculations.',
    button: 'Sell',
    action: 'S'
}

const SELL_BOND_NO_LIVE = {
    title: 'This security is not available',
    text: 'There is no live market active for this security. However, you can request a price quote from dealers if you wish to place a trade.',
    button: 'Bid wanted',
    action: 'W'
}

const SELL_BOND_NOT_OWN = {
    title: 'This security is not available',
    text: 'You do not currently hold any of this security to sell and E*TRADE does not allow short-selling of bonds. Keep in mind, current offer pricing listed in bond details may not align with price levels that result from custom calculations.',
}